import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  AvatarGroup,
  Card,
  Stack,
  Typography,
} from '@mui/material';
import { ReactNode } from 'react';
import { MaterialIcon } from '@common/ui/MaterialIcon';
import { AccessGroupIcon } from '../organisms/AccessSessionGroupList';
import { AnalyticsEvents } from '@common/utils/analytics/events';

interface AccessSessionGroupProps {
  groupName?: string;
  groupIcon?: string;
  groupIcons?: AccessGroupIcon[];
  total: number;
  children: ReactNode;
}

export default function AccessSessionGroupWrapper({
  groupName,
  groupIcon,
  groupIcons,
  total,
  children,
}: AccessSessionGroupProps) {
  if (!groupName) {
    return (
      <Card elevation={0} sx={{ borderRadius: 1 }}>
        {children}
      </Card>
    );
  }

  return (
    <Accordion disableGutters elevation={0} defaultExpanded sx={{ borderRadius: 1, '&:before': { display: 'none' } }}>
      <AccordionSummary
        expandIcon={<MaterialIcon symbol="expand_more" />}
        data-trigger={AnalyticsEvents.SessionGroupToggled}
      >
        <Stack direction="row" alignItems="center" spacing={1} sx={{ flex: 1 }}>
          <Avatar alt={groupName} src={groupIcon} sx={{ width: 20, height: 20 }} />
          <Typography variant="subtitle2">{groupName}</Typography>
          <Typography variant="body2" color="text.muted">
            {`(${total}`} session{total > 1 ? 's' : ''})
          </Typography>
        </Stack>
        <AvatarGroup>
          {groupIcons?.map((icon) => (
            <Avatar key={icon.alt} alt={icon.alt} src={icon.svg} sx={{ width: 20, height: 20 }} />
          ))}
        </AvatarGroup>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: 0 }}>{children}</AccordionDetails>
    </Accordion>
  );
}
